import type { FaireProductEntity } from "../../entity_types/product";

export const p_zrt49pg6us: FaireProductEntity = {
  token: "p_zrt49pg6us",
  type: "product",
  name: "Banana Ketchup - Award-Winning & Tomato-less Condiment",
  brandToken: "b_wvw4kcax73",
  brandName: "Fila Manila Filipino American Kitchen",
  imageUrl:
    "https://cdn.faire.com/fastly/a1282c7e0411c0d50ec81d710287a82e450ebe858e135713f5e2e417659f82e6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ae837bb3e5c6de0e97b24300de0fc8edd6233c7de8f52822ad59d9ee8041bce.png",
    "https://cdn.faire.com/fastly/7c989bc3d3e8be6c148d96164d3a1728bbdab463ce339d9fb6caa4f5c8ff0670.png",
    "https://cdn.faire.com/fastly/049a9f0109b8c2340d780e134a5b83874f4cf04123636bcffc1c44703b7fa97b.png",
    "https://cdn.faire.com/fastly/309f6123c9f9c424d3edba3d63ff9abc5c4ab1249f5bb94c8b07efd06827103c.jpeg",
    "https://cdn.faire.com/fastly/46731a4d524c866c3ebff1e1fea955ce2eaafe315d63c8f533f9495802652ea3.jpeg",
    "https://cdn.faire.com/fastly/d0eb84e333defd0ea0bbcfdb5b35f7907f87b49940e7fbd26c23ef137468976f.jpeg",
  ],
  priceDollars: 5.9,
  description:
    "This ketchup is literally Bananas! Yellow there! Get ready for tropical deliciousness with the sweet and tangy magic of Banana Ketchup! Born in the Philippines during WWII, Banana Ketchup was created to make the most out of the abundance of bananas and the shortage of tomatoes.\n\nSqueeze a little bit or a lotta-bit on burgers, fries, eggs, or anything that needs an oh-so-tasty tropical flavor infusion!\n\nLess sugar, more flavor! Our Banana Ketchup has only 2g of sugar per serving! That's half the sugar of tomato ketchup. Hope that makes you peel good!",
  tags: [],
  msrpDollars: 11.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:23.322Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
